export default __webpack_public_path__ + "static/media/outside.189543b9.jpg";